<template>
	<div
		:class="[
			`${arrowDirectionStyle} ${bgStyles} flex items-center absolute z-20 cursor-pointer ${
				arrowDirection === 'bottom'
					? 'rotate-90 right-[50%] translate-x-[50%] bottom-0 bg-white bg-opacity-75'
					: arrowDirection === 'top'
						? '-rotate-90 right-[50%] translate-x-[50%] top-0 bg-white bg-opacity-75'
						: ' '
			} `
		]"
	>
		<ChevronRightIcon :class="[`h-6 w-6 text-primary`]" />
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
	arrowDirection: String,
	isBg: Boolean
});
const { arrowDirection, isBg } = props;

const bgStyles = computed(() => {
	return isBg
		? "mx-2 flex items-center justify-center w-10 h-10 transition-all bg-white bg-opacity-75 rounded-full hover:bg-opacity-100"
		: "w-6 h-12";
});
const arrowDirectionStyle = computed(() => {
	return arrowDirection === "left"
		? "left-0 rotate-180 top-1/2 -translate-y-1/2"
		: "right-0 top-1/2 -translate-y-1/2";
});
</script>
